"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";

export default function Pagination({ totalPages }: { totalPages: number; }) {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const createQueryString = useCallback(
        (name: string, value: string) => {
            const params = new URLSearchParams(searchParams.toString());
            params.set(name, value);
            return params.toString();
        },
        [searchParams]
    );

    const currentPage = searchParams.get("page") ?? "1";
    const currentPageNum = parseInt(currentPage);

    const isLastPage = currentPageNum >= totalPages;

    const handleNextPage = () => {
        if (isLastPage) return;
        const nextPage = (currentPageNum + 1).toString();
        router.push(`${pathname}?${createQueryString("page", nextPage)}`);
    };

    const handlePreviousPage = () => {
        if (currentPageNum <= 0) return;
        const prevPage = (currentPageNum - 1).toString();
        router.push(`${pathname}?${createQueryString("page", prevPage)}`);
    };

    return (
        <div className="sticky bottom-10 md:bottom-15 left-0 right-0 py-4 flex gap-[24px] flex-wrap items-center justify-center">
            <div className="flex absolute justify-between items-center w-[10rem] h-12 px-4 gap-x-4 backdrop-blur-md bg-white/70 border border-neutral-300 rounded-full shadow-sm">
                <button
                    onClick={handlePreviousPage}
                    className={`w-12 h-12 flex justify-center items-center rounded-full ${currentPageNum <= 0 ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                    disabled={currentPageNum <= 0}
                >
                    <ChevronLeft size={24} className="text-yellow-300 cursor-pointer" />
                </button>

                <p className="text-sm text-neutral-700 flex-row flex items-center justify-center w-full">
                    {currentPageNum} / {totalPages}
                </p>

                <button
                    onClick={handleNextPage}
                    className={`w-12 h-12 flex justify-center items-center rounded-full ${isLastPage ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                    disabled={isLastPage}
                >
                    <ChevronRight size={24} className="text-yellow-300 cursor-pointer" />
                </button>
            </div>
        </div>
    );
}